import { useState } from 'react'

import { CalendarFilter } from '../../models/CalendarFilter'
import { Item } from '../../models/Item'
import { User } from '../../models/User'
import { Icon } from '../Icon'
import Badge from '../app/design/Badge'
import Button from '../app/design/Button'
import Label from '../app/design/Label'
import { CalendarFilterModal } from './CalendarFilterModal'

type Props = {
    filter: CalendarFilter
    pros: User[]
    items: Item[]
    compact?: boolean
    updateFilter: (filter: CalendarFilter) => void
}

export const CalendarFilterButton = ({
    filter,
    pros,
    items,
    compact = false,
    updateFilter,
}: Props) => {
    const [showFilterModal, setShowFilterModal] = useState(false)

    const count = filter.allPeople.length + filter.allItems.length

    const onDone = (filter: CalendarFilter) => {
        setShowFilterModal(false)
        updateFilter(filter)
    }

    return (
        <>
            <Button size="small" className="relative" onClick={() => setShowFilterModal(true)}>
                <Icon icon="filter.small" />
                {!compact && (
                    <Label size="sm" className="text-primary-700 pointer-events-none">
                        Filter
                    </Label>
                )}
                {count > 0 && (
                    <Badge
                        value={count}
                        className={`pointer-events-none ${compact ? 'absolute top-[-8px] right-[-6px]' : ''}`}
                    />
                )}
            </Button>

            <CalendarFilterModal
                isOpen={showFilterModal}
                filter={filter}
                pros={pros}
                items={items}
                onDone={onDone}
                onClose={() => setShowFilterModal(false)}
            />
        </>
    )
}
